import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { WhoGuidesYou } from './components/WhoGuidesYou';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1443459693942372');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen pb-16 bg-beige font-sans text-brown-dark selection:bg-gold selection:text-brown-dark" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1443459693942372&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <PainPoints data-id="element-5" />
      <Solution data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Urgency data-id="element-8" />
      <Offer data-id="element-9" />
      <Testimonials data-id="element-10" />
      <WhoGuidesYou data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}